"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_error_1 = require("./client.error");
const unexpected_client_error_1 = require("./unexpected.client.error");
class AuthFailedError extends client_error_1.ClientError {
    constructor(response) {
        super(response);
        Object.setPrototypeOf(this, AuthFailedError.prototype);
        switch (response.errorCode) {
            case 'INVALID_CREDENTIALS':
            case 'AUTH_FAILED':
            case 'PENDING_USER':
                this.captchaRequired = false;
                break;
            case 'AUTH_MAX_ERROR_TRIES':
                this.captchaRequired = true;
                break;
            default:
                throw new unexpected_client_error_1.UnexpectedClientError(response);
        }
    }
}
exports.AuthFailedError = AuthFailedError;
//# sourceMappingURL=auth.failed.error.js.map